// extracted by mini-css-extract-plugin
module.exports = {"container":"DiseasedWeekTable_container__d7sAT"};